import { render, staticRenderFns } from "./media-section.vue?vue&type=template&id=563a444f&scoped=true&"
import script from "./media-section.vue?vue&type=script&lang=js&"
export * from "./media-section.vue?vue&type=script&lang=js&"
import style0 from "./media-section.vue?vue&type=style&index=0&id=563a444f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a444f",
  null
  
)

export default component.exports